module.exports = __webpack_public_path__ + "img/tile-image.dfe11308.png";